import { InjectionToken } from '@angular/core'
import type { PersistState } from '@datorama/akita'

export const PERSIST_STORAGE = new InjectionToken<PersistState>('persistStorage')
